import { render, staticRenderFns } from "./ClientSearches.vue?vue&type=template&id=77c78b13&"
import script from "./ClientSearches.vue?vue&type=script&lang=ts&"
export * from "./ClientSearches.vue?vue&type=script&lang=ts&"
import style0 from "./ClientSearches.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports